// extracted by mini-css-extract-plugin
export var container = "AccordionPanel-module--container--fad03";
export var content = "AccordionPanel-module--content--3f367";
export var divider = "AccordionPanel-module--divider--91e06";
export var fullWidth = "AccordionPanel-module--fullWidth--73019";
export var narrow = "AccordionPanel-module--narrow--9f8a3";